export default "__VITE_ASSET__C2U93uWt__"